import React from 'react'
import PropTypes from 'prop-types'
import {
  ShowcaseWrapper,
  ShowcaseCard,
  CardUpper,
  CardOptions,
  IconsWrapper,
  ShowcaseOuter,
  Text,
} from './Showcase.styles'
import { GatsbyImage } from 'gatsby-plugin-image'
import { v4 as uuidv4 } from 'uuid'

const Showcase = ({ content, headPhrase, bgColor, textMin, isGrayed }) => (
  <ShowcaseOuter>
    <ShowcaseWrapper bgColor={bgColor}>
      {content.map((card) => (
        <ShowcaseCard key={uuidv4()}>
          <GatsbyImage image={card.image} style={{ maxWidth: `328px` }} alt="" />
          <CardUpper>
            <p className="name">{card.name}</p>
            <p>{card.role}</p>
          </CardUpper>

          {card.options && (
            <CardOptions>
              {headPhrase && <p className="help">{headPhrase}</p>}
              {card.options.map((option) => (
                <li key={uuidv4()}>{option}</li>
              ))}
            </CardOptions>
          )}
          <Text textMin={textMin}>
            {card.para && <p className="para">{card.para}</p>}
            <IconsWrapper isGrayed={isGrayed}>
              {card.icons &&
                card.icons.map((icon, i) => (
                  <React.Fragment key={`showcase-icon-${i}`}>
                    {icon}
                  </React.Fragment>
                ))}
            </IconsWrapper>
          </Text>
        </ShowcaseCard>
      ))}
    </ShowcaseWrapper>
  </ShowcaseOuter>
)

Showcase.defaultProps = {
  isGrayed: true,
}

Showcase.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
  isGrayed: PropTypes.bool,
}

export default Showcase
